import MandateNotFilledAlert from './MandateNotFilledAlert';

export default MandateNotFilledAlert;
